import { UIHeading4, UIText1 } from '@cian/ui-kit';

import * as React from 'react';

import {
  trackClickDeleteSavedSearch,
  trackClickEditSavedSearch,
  trackDeleteSuccessSavedSearch,
  trackEditSuccessSavedSearch,
  trackNavigateToSavedSearch,
} from './trackings';

import { DeleteModal } from '../DeleteModal';
import { EditModal } from '../EditModal';
import { ActionsMenuContainer } from '../../../../containers/SavedSearches/ActionsMenuContainer';
import { ISavedSearch } from '../../../../types/savedSearch';

import styles from './styles.css';

export interface ISearchCardsItemProps extends ISavedSearch {
  description?: string | null;
  name?: string;
  link?: string;
  onRemove(): void;
  onSave(value: string): void;
}

export const SearchCardsItem: React.FC<ISearchCardsItemProps> = ({ name, link, description, onRemove, onSave }) => {
  const [isActionsMenuOpened, setActionsMenuOpened] = React.useState(false);
  const [isDeleteModalOpened, setDeleteModalOpened] = React.useState(false);
  const [isEditModalOpened, setEditModalOpened] = React.useState(false);

  const handleOpenDeleteModal = React.useCallback(() => {
    setActionsMenuOpened(false);
    setDeleteModalOpened(true);
    trackClickDeleteSavedSearch(link);
  }, []);

  const handleOpenEditModal = React.useCallback(() => {
    setActionsMenuOpened(false);
    setEditModalOpened(true);
    trackClickEditSavedSearch(link);
  }, []);

  const handleDelete = React.useCallback(() => {
    setDeleteModalOpened(false);
    onRemove();
    trackDeleteSuccessSavedSearch(link);
  }, []);

  const handleSave = React.useCallback((value: string) => {
    setEditModalOpened(false);
    onSave(value);
    trackEditSuccessSavedSearch(link);
  }, []);

  return (
    <>
      <div className={styles['container']}>
        <a
          href={link}
          rel="noreferrer"
          target="_blank"
          onClick={() => trackNavigateToSavedSearch(link)}
          className={styles['content']}
        >
          <div className={styles['title']}>
            <UIHeading4>{name}</UIHeading4>
          </div>
          <div>
            {description && (
              <div className={styles['description']}>
                <UIText1>{description}</UIText1>
              </div>
            )}
          </div>
        </a>
        <div>
          <ActionsMenuContainer
            isOpen={isActionsMenuOpened}
            name={name}
            description={description}
            onOpenChange={setActionsMenuOpened}
            onOpenDeleteModal={handleOpenDeleteModal}
            onOpenEditModal={handleOpenEditModal}
          />
        </div>
      </div>
      <DeleteModal
        isOpen={isDeleteModalOpened}
        onOpenChange={() => setDeleteModalOpened(false)}
        onDelete={handleDelete}
      />
      <EditModal
        isOpen={isEditModalOpened}
        initialName={name}
        onOpenChange={() => setEditModalOpened(false)}
        onSave={handleSave}
      />
    </>
  );
};
